import { ICadastralField } from '../../../types/reducers/rosreestrData';

/**
 * Вычисляет доступность кнопки проверки кадастровых номеров
 *
 * @param buildingNumber - кадастровый номер здания
 * @param landNumber - кадастровый номер участка
 */
export const disableChecking = (buildingNumber: ICadastralField, landNumber: ICadastralField): boolean => {
  const buildingIsChecked = !!buildingNumber.isChecked;
  const buildingIsValid = buildingNumber.value && !buildingNumber.error;

  const landIsChecked = !!landNumber.isChecked;
  const landIsValid = landNumber.value && !landNumber.error;

  const isInvalidFields = !buildingIsValid && !landIsValid;
  const isCheckedFields = buildingIsChecked && landIsChecked;

  return (
    isInvalidFields || isCheckedFields || (buildingIsChecked && !landIsValid) || (!buildingIsValid && landIsChecked)
  );
};
